import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { ProjectContextService } from '@core/services/project-context.service';
import { NO_PROJECT_ID } from '@core/models/project.model';

const GENERAL_DATA_ENTRY_ROUTES = new Set(['audits', 'observations', 'ncrs', 'inspection-enhanced', 'capas']);

/**
 * Ensures a project context is established before entering data routes (Group H).
 * - A user with a selected project proceeds.
 * - Admins (COE) proceed without a selection — they implicitly see all projects.
 * - Otherwise the user is redirected to the project selector to choose one.
 */
export const projectSelectedGuard: CanActivateFn = route => {
  const ctx = inject(ProjectContextService);
  const router = inject(Router);

  return ctx.ensureLoaded().pipe(
    map(projects => {
      if (ctx.hasSelection() || ctx.isAdmin()) {
        return true;
      }
      const generalData = projects.find(project => project.id === NO_PROJECT_ID);
      if (generalData && GENERAL_DATA_ENTRY_ROUTES.has(route.routeConfig?.path ?? '')) {
        ctx.setCurrentProject(generalData);
        return true;
      }
      return router.createUrlTree(['/projects']);
    }),
  );
};
